import React, { useEffect } from 'react';
import { getProductEntityName } from '../Product.config';

import { useAssignValidationDesignInput } from '../Product.hooks';
import {
  ProductDesignInput,
  BaseProductAssignDialogProps
} from '../Product.interface';
import AssignDesignInputDialog from './AssignDesignInputDialog';

export type ValidationAssignDesignInputDialogProps = BaseProductAssignDialogProps<'validationId'>;

const ValidationAssignDesignInputDialog: React.FC<ValidationAssignDesignInputDialogProps> = (
  props: ValidationAssignDesignInputDialogProps
) => {
  const {
    open,
    productId,
    validationId,
    selectedItems,
    onCancel,
    onError,
    onAssigned
  } = props;
  const {
    updatedProductValidation,
    isAssigning,
    error: assignError,
    assignDesignInputs
  } = useAssignValidationDesignInput(productId, validationId);

  // handle notification to parent after assigning
  useEffect(() => {
    if (updatedProductValidation) {
      onAssigned?.(updatedProductValidation);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updatedProductValidation]);

  useEffect(() => {
    if (assignError) {
      onError?.(assignError);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [assignError]);

  return (
    <AssignDesignInputDialog
      {...{ open, productId, selectedItems, onCancel, onError }}
      isLoading={isAssigning}
      contentText={`Search for ${getProductEntityName(
        'designInput'
      )} to assign to the ${getProductEntityName('validation')}.`}
      onSubmit={(designInputs: ProductDesignInput[]) => {
        assignDesignInputs({
          designInputIds: designInputs.map(
            (designInput: ProductDesignInput) => designInput.id
          )
        });
      }}
    />
  );
};

export default ValidationAssignDesignInputDialog;
